import { ChangeDetectorRef, Directive, ElementRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PrettyLicensePlateService } from '../utilities/pretty-license-plate.service';

/** @deprecated - this is moved to libs */
@Directive({
    selector: '[prettyLicensePlate]',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: PrettyLicensePlateDirective,
        multi: true
    }],
    host: {
        '[disabled]': 'disabled',
        '(keyup)': 'inputChanged($event)',
        '(blur)': 'onBlur()'
    }
})
export class PrettyLicensePlateDirective implements ControlValueAccessor {

    /**
     * Getters & setters
     */
    get nativeElementValue(): string {
        return this.elementRef.nativeElement.value;
    }

    set nativeElementValue(value: string) {
        this.elementRef.nativeElement.value = value;
    }

    get trimmedValue(): string {
        return this.prettyLicensePlateService.trim(this.nativeElementValue);
    }
    public disabled: boolean = false;

    constructor(
        protected elementRef: ElementRef,
        private renderer: Renderer2,
        private prettyLicensePlateService: PrettyLicensePlateService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    /**
     * Control value accessor methods
     */
    public writeValue(value: string): void {
        if (value) {
            this.nativeElementValue = this.prettyLicensePlateService.format(value);
        } else {
            this.nativeElementValue = '';
        }
    }

    public registerOnChange(fn: (value: string) => {}): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => {}): void {
        this.onTouch = fn;
    }

    public setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    /**
     * Handle input changes on keyup
     */
    public inputChanged(event: KeyboardEvent): void {
        // if input is - (dash) we ignore it
        if (event.key === '-') {
            return;
        }

        // format input
        this.nativeElementValue = this.prettyLicensePlateService.format(this.nativeElementValue);

        // remove any non-alphanumeric characters before we emit changes
        if (this.trimmedValue.length === 6) {
            this.updateControl(this.trimmedValue);
        }

        // reset on empty value
        if (this.trimmedValue.length === 0) {
            this.updateControl(null);
        }
    }

    public onBlur(): void {
        if (this.trimmedValue.length === 0) {
            this.updateControl(null);
        }
    }

    private onChange = (value: string) => { };
    private onTouch = () => { };

    /**
     * Prepare for change detection and emit change
     */
    private updateControl(licensePlate: string | null): void {
        this.changeDetectorRef.markForCheck();

        this.onChange(licensePlate);
        this.onTouch();
    }
}
